import { useParams } from 'react-router-dom';
import { useMutation } from '@apollo/client';
import Button from '../components/Button';
import { Modal, ModalName, ModalPart } from '../components/Modal';
import { deleteCommentCache } from '../utilities/cache';
import { DELETE_COMMENT } from '../utilities/mutations';

const DeleteCommentModal = ({ commentId, onClose }) => {
  const params = useParams();
  const [deleteComment] = useMutation(DELETE_COMMENT, {
    variables: { id: commentId },
    update: (cache, { data: { deleteComment } }) =>
      deleteCommentCache(params.s, params.t, cache, deleteComment),
  });

  const close = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal onClose={() => close()} isDanger>
      <ModalName>Delete comment</ModalName>
      <ModalPart>Are you sure you want to delete this comment?</ModalPart>
      <ModalPart>
        <Button onClick={() => close()} isExtended>
          Cancel
        </Button>
        <Button
          onClick={() => {
            deleteComment();
            if (onClose) {
              onClose();
            }
          }}
          isDanger
          isExtended
        >
          Delete
        </Button>
      </ModalPart>
    </Modal>
  );
};

export default DeleteCommentModal;
